import { stakeholderService } from '../services'

export default (clientId) => {
	return new Promise((resolve, reject) => {
		stakeholderService.getFormC57(clientId)
			.then(response => resolve({ success: true, data: response.data }))
			.catch(err => reject({ error: true }))
		})
}
